<template>
  <div class="landing-page-success">
    <div class="message-card">
      <svg xmlns="http://www.w3.org/2000/svg" width="88" height="88" viewBox="0 0 88 88">
        <g fill="none" fill-rule="evenodd">
          <path d="M-5-4h96v96H-5z"/>
          <path fill="#292929"
                d="M62.637 64.15a1.775 1.775 0 0 0-.248 2.157c.253.422 2.301 4.224-2.053 7.474a1.765 1.765 0 0 0-.62 2.022c.026.08.649 1.977-.415 3.833-.985 1.72-.67 2.941-3.915 3.626-2.61.555-6.131.662-10.474.32a1.462 1.462 0 0 0-.178-.004c-9.021.184-18.135-.95-18.596-1.008l-1.61-.246c.098-.422.153-.856.153-1.309V57.91c0-.616-.097-1.204-.276-1.761.272-1.015 1.001-3.155 2.701-4.978 6.391-5.03 11.44-18.416 11.707-19.143.102-.282.133-.59.083-.887-.26-1.678.851-3.03 1.235-3.534.71.007 2.535-.555 3.842 1.244 1.488 2.044 2.048 1.98.46 6.775-2.38 7.18-2.602 10.944-.74 12.587.912.806 2.114.848 2.994.528a51.29 51.29 0 0 1 2.506-.507c.057-.012.117-.024.176-.038 3.036-.661 9.536-1.842 12.632.974 2.391 2.174.703 5.042.51 5.35-.47.73-.334 1.705.307 2.295.017.014 1.58 1.462 1.648 3.437.04 1.287-.577 2.6-1.831 3.904l.002-.005zM13.83 83.222a2.22 2.22 0 0 1-2.22-2.21V57.907a2.22 2.22 0 0 1 2.22-2.211h5.03c.772 0 1.454.398 1.852.995.043.304.153.59.334.83.021.126.038.251.038.386v23.107c0 1.216-1 2.209-2.223 2.209H13.83zm54.233-23.147c-.086-2.14-1.082-3.844-1.874-4.866.942-2.266 1.342-5.874-1.753-8.683-5.07-4.605-14.591-2.105-15.943-1.806l-.012.002c-.768.138-1.57.3-2.394.484-.098-.84-.01-3.081 1.774-8.462 1.993-6.016 1.259-6.936-.968-9.991-2.335-3.212-5.71-2.726-6.804-2.726-1.054 0-1.972.42-2.651 1.211-1.574 1.82-2.33 4.568-2.163 5.98-1.875 5.026-5.964 13.758-10.483 17.21a1.893 1.893 0 0 0-.21.182c-1.347 1.413-2.241 2.956-2.83 4.278a5.823 5.823 0 0 0-2.898-.772h-5.029c-3.21 0-5.825 2.598-5.825 5.79v23.107c0 3.193 2.613 5.79 5.825 5.79h5.03a5.821 5.821 0 0 0 3.517-1.185l3.245.491c.01.003.024.005.036.007.391.05 9.61 1.23 19.065 1.04 1.705.131 3.303.198 4.783.198 2.56 0 4.777-.197 6.63-.588 4.337-.915 4.83-2.743 6.338-5.43 1.164-2.075 1.133-4.151.942-5.44 3.892-3.48 3.648-7.662 2.659-10.217 1.402-1.768 2.077-3.65 1.993-5.601v-.003z"/>
          <path stroke="#292929" stroke-dasharray="1,6" stroke-linecap="round" stroke-width="4"
                d="M61 24l15-9M71 36l16-2M49 16l7-14M34 16L25 0M21 25L7.038 17.962M17.107 38.962H-.962"/>
        </g>
      </svg>
      <span>{{$t('step5.success.title')}}</span>
    </div>

    <div class="landing-page">
      <router-link :to="{name: 'home'}" tag="a" class="submit">
        {{$t('step5.success.btn')}}
      </router-link>
      <router-link :to="{name: 'step4'}" tag="a" class="next" v-if="hasBooking">
        {{ $t('step5.shopping-cart.btn') }} <span>({{ redirectIn }})</span>
      </router-link>
    </div>
  </div>

</template>

<script>
  import {mapState} from "vuex";

  export default {
    name: "payment-success",
    computed: {
      ...mapState({
        hasBooking: s => s.shoppingCart.bookings.length > 0
      })
    },
    data() {
      return {
        redirectIn: 5,
      }
    },
    methods: {
      asyncDecrement() {
        if (this.redirectIn === 0) {
          this.$router.push({name: 'step4'});
          return;
        }
        setTimeout(() => {
          this.redirectIn--;
          this.asyncDecrement();
        }, 1000);
      }
    },
    mounted() {
      window.onbeforeunload = () => true;
      if (this.hasBooking) {
        this.asyncDecrement();
      }
    },
    beforeDestroy() {
      window.onbeforeunload = null;
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/tunnel/step5/payment-success.vue